import React, { useEffect } from 'react';
import { isMobileOnly, isTablet } from 'react-device-detect';
import Div100vh from 'react-div-100vh';
import { useOrientation, useUpdate } from 'react-use';

function isWechat() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

export const PlatformDetector: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const orientation = useOrientation();
  const update = useUpdate();
  const inWechatWithoutVcourse = isWechat() && !location.href.match(/vcourse/);

  useEffect(() => {
    update();
  }, [orientation, update]);

  useEffect(() => {
    if (inWechatWithoutVcourse) {
      window.location.replace(`${window.location.origin}/video-course`);
    }
  }, [inWechatWithoutVcourse]);

  if (inWechatWithoutVcourse) {
    return (
      <Div100vh className="flex justify-center items-center text-2xl pb-36 text-[#797979]">
        正在跳转到课程页面…
      </Div100vh>
    );
  }

  return children;
};
